import * as React from 'react';
import { authenticationService } from '../services/authentication';
import { Link, NavLink } from 'react-router-dom';
import { LogoutIcon } from './common/Icons';
import { injectProfile, ProfileInjectorProperties } from './hocs/ProfileInjector';
import { injectBillingPeriod, BillingPeriodInjectorProperties } from './hocs/BillingPeriodInjector';
import logoTipSvgUrl from 'src/webportal/theme/images/slack-new-logo.svg';

interface TopBarProperties extends ProfileInjectorProperties, BillingPeriodInjectorProperties {
    isUserSuspended: boolean;
}

function TopBar(props: TopBarProperties): JSX.Element {
    function getTrialDaysLabel(): JSX.Element | null {
        if (!props.billingPeriod) {
            return null;
        }

        const trialDays = props.billingPeriod.trialDays;
        const trialLabelText = trialDays! < 1 ? 'less than a day' : `${trialDays} days`;
        const trialLabelHtml = (
            <div className="msglabel">
                <span>Trial ends in {trialLabelText}</span>
            </div>
        );
        const isInTrial = props.billingPeriod.trialDays !== undefined;
        return isInTrial ?
            trialLabelHtml :
            null;
    }

    function getSuspendedUserLabel(): JSX.Element | null {
        return (
            <div className="msglabel">
                <span>Suspended</span>
            </div>
        );
    }
    return (
        <>
            <div className="top__line">
                <div className="container">
                    <div className="row d-flex align-items-center">
                        <div className="col-6 col-lg-4">
                            <div className="msgbox">
                                <div className="slack">
                                    <a href="https://join.slack.com/t/lucidlink-community/shared_invite/zt-2rcoblmd1-mYQPyMhw_RBIk0MnNMTOpA">
                                        <img src={logoTipSvgUrl} />
                                        <span className="desktop">
                                            <em>Join us on Slack</em>
                                            LucidLink Community
                                        </span>
                                    </a>
                                </div>
                                {props.isUserSuspended ? getSuspendedUserLabel() : getTrialDaysLabel()}
                            </div>
                        </div>
                        <div className="col-6 col-lg-8">
                            <Link
                                to={'#'}
                                className="logout"
                                onClick={authenticationService.signOut}
                            >
                                <LogoutIcon width="18px" height="18px" />
                            </Link>
                            <div className="user d-none d-md-block">
                                <ul className="data">
                                    <li className="name">Hello, {props.attributes.firstName}</li>
                                    <li className="email">{props.email}</li>
                                </ul>
                                <ul className="userNav">
                                    <li><NavLink to={'/profile'} activeClassName="active">Profile</NavLink></li>
                                    <li><NavLink to={'/billing'} activeClassName="active">Billing</NavLink></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default injectProfile(injectBillingPeriod(TopBar) as any);



// WEBPACK FOOTER //
// ./src/webportal/components/TopBar.tsx